import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  default: "/api/v1/operator",
  create: "/create",
  update: "/update",
  delete: "/delete",
};

/**
 * createOperatorStep2 vs createOperator is that step2 uses admin api key
 */
export async function createOperatorStep2(values) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.create;

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      ...values,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function createOperator(values, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.create;

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data: {
      ...values,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function updateOperator(values, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.update;

  var config = {
    method: "patch",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data: {
      ...values,
    },
  };

  try {
    const response = await axios(config);
    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function getOperator(id, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + "?operator_id=" + id;

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function deleteOperator(operator_id, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.delete;

  var config = {
    method: "delete",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data: {
      operator_id,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}
